import type { Filter } from 'components/filters/useStreamFilters'

export function shouldShowOrdinalOwnerAvatar(
    filter?: Pick<Filter, 'ordinals' | 'ordinals_scope' | 'user_ordinals'> | null,
): boolean {
    // A profile's Ordinals tab already identifies the owner in its header.
    // My Ordinals is still a stream of cards and keeps the card-level owner affordance.
    return !filter?.user_ordinals
}
